import React, { useState } from 'react'
import { Box, Typography } from '@mui/material'
import { StockTable } from '../component/eco-stocklist/StockTable'
import { StockFilter } from '../component/eco-stocklist/StockFilter'
import { ItemFilter } from '../component/eco-stocklist/ItemFilter'
import { Navbar } from '../component/shared/Navbar'
import { PageContainer } from '../component/styled/PageContainer'
import { Helmet } from 'react-helmet-async'

export const StockScreenEco = () => {
  const [department, setDepartment] = useState('')
  const [itemId, setItemId] = useState('')
  return (
    <PageContainer>
      <Helmet titleTemplate='%s | Staff Portal' defaultTitle='Staff Portal'>
        <title>ECO Stock List</title>
      </Helmet>
      <Navbar />
      <Box p={{ xs: 3, md: 5 }}>
        <Box mb={2}>
          <Typography variant='h5'>Inventory</Typography>
        </Box>
        <StockFilter
          department={department}
          setDepartment={setDepartment}
          itemId={itemId}
          setItemId={setItemId}
        />
        {department && <ItemFilter department={department} setItemId={setItemId} itemId={itemId} />}
        {<StockTable department={department} itemId={itemId} />}
      </Box>
    </PageContainer>
  )
}
